import { createStore, applyMiddleware, combineReducers } from "redux";
import LoginReducer from "./Reducers/LoginReducers";
import TableReducer from "./Reducers/TableReducer";
import TaskReducer from "./Reducers/TaskReducers"
import thunk from "redux-thunk";

const logger = ({ getState }) => {
  return (next) => (action) => {
    // console.log("will dispatch", action);
    const returnValue = next(action);
    // console.log("state after dispatch", getState());
    return returnValue;
  };
};
const rootReducer = combineReducers({
  auth: LoginReducer,
  pagination: TableReducer,
  taskpagination: TaskReducer,
});

const Store = createStore(rootReducer, applyMiddleware(logger, thunk));
export default Store;
 